export const eventConstants = {
  GETALL_REQUEST: 'EVENTS_GETALL_REQUEST',
  GETALL_SUCCESS: 'EVENTS_GETALL_SUCCESS',
  GETALL_FAILURE: 'EVENTS_GETALL_FAILURE',

  GET_REQUEST: 'EVENTS_GET_REQUEST',
  GET_SUCCESS: 'EVENTS_GET_SUCCESS',
  GET_FAILURE: 'EVENTS_GET_FAILURE',

  ADD_REQUEST: 'EVENTS_ADD_REQUEST',
  ADD_SUCCESS: 'EVENTS_ADD_SUCCESS',
  ADD_FAILURE: 'EVENTS_ADD_FAILURE',

  UPDATE_REQUEST: 'EVENTS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'EVENTS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'EVENTS_UPDATE_FAILURE',
}